<template>
    <div
        v-if="label"
        class="input-label flex flex-row items-baseline flex-wrap mr-4 relative w-full"
        :class="{
            'mb-4': type !== 'checkbox' && type !== 'radio',
            'text-gray-400' : disabled,
            'text-gray-700': !disabled
        }"
    >
        <label
            class="field-label inline-block uppercase tracking-wider relative text-sm"
            :class="{
                'cursor-pointer' : !disabled,
                'cursor-not-allowed' : disabled,
            }"
            :for="labelFor"
        >
            <span v-html="enabledDisabledLabel" /><span v-if="required">&nbsp;*</span>

            <a
                v-if="hasHelp"
                class="help-bubble ml-2 cursor-pointer w-5 absolute top-0"
                :title="strippedHelpText"
                @click.prevent="showHelpText = !showHelpText">
                <svg-icon
                    icon="question"
                    class="bg-white transform transition-scale duration-100 w-5 h-5 inline-block text-gold-500 hover:bg-black-500 hover:scale-125 cursor-pointer"
                />
            </a>
        </label>
        <div
            v-if="showHelpText"
            class="help-text text-gray-600 mt-1 mb-3 w-full text-xs tracking-wide block"
            :class="{'italic': type === 'checkbox'}"
            v-html="helpText" />
    </div>
</template>

<script>
import SvgIcon from '@whisper/components/icons/SvgIcon';
import { isEmpty, get } from 'lodash';

export default {
  name: 'FormFieldLabel',
  components: { SvgIcon },
  props: {
    labelFor: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
    disabledLabel: {
      type: String,
    },
    helpText: {
      type: String,
    },
    required: {
      type: Boolean,
    },
    type: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
  },
  data: () => ({
    showHelpText: false,
  }),
  computed: {
    strippedHelpText() {
      const regex = /(<([^>]+)>)/ig;
      return this.helpText.replace(regex, '');
    },
    hasHelp() {
      return !isEmpty(this.helpText);
    },
    enabledDisabledLabel() {
      if (this.disabled) {
        return get(this, 'disabledLabel', this.label);
      }
      return this.label;
    },
  },
};
</script>
<style lang="scss">
.input-label {
    .field-label {
        max-width: calc(100% - 1.25rem);

        .help-bubble {
            right: -1.5rem;
        }
    }

    .help-text {
        ul {
            @apply list-square ml-4;
        }
    }
}
</style>
